import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { CompaniesCreate } from './CompaniesCreate';
import { CompaniesEdit } from './CompaniesEdit';
import { CompaniesList } from './CompaniesList/CompaniesList';
import { CompaniesShow } from './CompaniesShow';

export const companiesResource: ResourceProps = {
  name: Resources.Companies,
  create: CompaniesCreate,
  edit: CompaniesEdit,
  list: CompaniesList,
  show: CompaniesShow,
};
